import { Component, OnInit } from '@angular/core';
import { Globals } from 'src/app/global';

@Component({
  selector: 'app-loan-timeline',
  templateUrl: './loan-timeline.component.html',
  styleUrls: ['./loan-timeline.component.scss']
})
export class LoanTimelineComponent implements OnInit {

  constructor(public globals: Globals) { }

  section_modal: string = '';

  ngOnInit() {
    var modal=this.globals.getModalValue();
    if(undefined!=modal){
      this.section_modal=modal;
    }

    console.log("i am here");
  }

  setValue(value) {
    this.globals.setValue(value);
  }
}
